import React, { FC } from 'react';
import HistoricalTable from './table/table.component';
import HistoricalLineChart from './chart/chart.component';
import { ValuesType } from '../controlBar/controlBar.component';
import type { HistoricalDataPayload } from '../../../../../../api/rs-hg/risk/historicalData.types';

export interface IDataViewProps {
  data: HistoricalDataPayload;
  fourShowing: boolean;
  showTable: boolean;
  keysAndDates: ValuesType;
  external: boolean;
  adjustedHeight: number;
  dimensions: { width: number; height: number };
}

const HistoricalDataView: FC<IDataViewProps> = (props) => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {!props.showTable ? (
        <HistoricalTable
          external={props.external}
          datesAndKeys={props.keysAndDates}
          dimensions={props.dimensions}
          data={props.data}
          height={props.adjustedHeight}
        />
      ) : (
        <HistoricalLineChart
          fourShowing={props.fourShowing}
          height={props.adjustedHeight}
          dimensions={props.dimensions}
          data={props.data}
          datesAndKeys={props.keysAndDates}
        />
      )}
    </div>
  );
};

export default HistoricalDataView;
